if(window.__mfSpLoaded){}else{window.__mfSpLoaded=true;
(function(){"use strict";
var PLANS=[{id:691326550355,name:"Every 4 weeks",price:2699},{id:691326583123,name:"Every 6 weeks",price:2899},{id:691326615891,name:"Every 8 weeks",price:3099}];
var OT={price:3299};
var SERVINGS=25;
var PND="\xA3";
function fmt(p){return PND+(p/100).toFixed(2);}
function perSrv(p){return (p/100/SERVINGS).toFixed(2);}

function showStrike(){
  var ps=document.querySelector(".product-information");if(!ps)return;
  if(document.getElementById("mf-ot-strike")){document.getElementById("mf-ot-strike").style.display="";return;}
  var priceEl=ps.querySelector(".price__regular .price,.price__sale .price");if(!priceEl)return;
  var s=document.createElement("s");s.id="mf-ot-strike";
  s.style.cssText="color:#9ca3af;font-weight:400;margin-right:8px;font-size:14px;";
  s.textContent=fmt(OT.price)+" GBP";
  priceEl.parentNode.insertBefore(s,priceEl);
  priceEl.parentNode.style.cssText+="display:flex;align-items:center;gap:8px;flex-wrap:wrap;";
}
function hideStrike(){var el=document.getElementById("mf-ot-strike");if(el)el.style.display="none";}

function setSP(id){
  var f=document.querySelector("form[action='/cart/add']");if(!f)return;
  var i=f.querySelector("input[name='selling_plan']");
  if(!i){i=document.createElement("input");i.type="hidden";i.name="selling_plan";f.appendChild(i);}
  i.value=id;
}
function rmSP(){
  var f=document.querySelector("form[action='/cart/add']");if(!f)return;
  var i=f.querySelector("input[name='selling_plan']");if(i)i.remove();
}

function updatePagePrice(pence){
  var ps=document.querySelector(".product-information");if(!ps)return;
  var el=ps.querySelector(".price__regular .price,.price__sale .price");
  if(el)el.textContent=fmt(pence)+" GBP";
  var ps2=ps.querySelector(".price__per-serving");
  if(ps2)ps2.style.display="none";
}
function updatePickerPrice(pence){
  var pp=document.getElementById("mf-picker-price");
  if(pp)pp.textContent=fmt(pence);
  var pp2=document.getElementById("mf-picker-per-serving");
  if(pp2)pp2.textContent=PND+perSrv(pence)+" per serving";
}
function updateMain(pence){updatePagePrice(pence);updatePickerPrice(pence);}

function onPlan(e){
  var id=parseInt(e.target.value,10);
  var plan=PLANS.find(function(pl){return pl.id===id;});
  if(!plan)return;
  setSP(plan.id);updatePagePrice(plan.price);updatePickerPrice(plan.price);updateStickyPerServing(plan.price);
}

function fixStickyBar(){
  if(!isTubPage())return;
  var sticky=document.querySelector("sticky-add-to-cart");if(!sticky)return;
  // CSS: hide native per-serving inside sticky bar
  if(!document.getElementById("mf-sticky-style")){
    var st=document.createElement("style");st.id="mf-sticky-style";
    st.textContent="sticky-add-to-cart p{display:none!important;}sticky-add-to-cart .price__per-serving,sticky-add-to-cart .price__per-unit,.sticky-add-to-cart p{display:none!important;}";
    document.head.appendChild(st);
  }
  // Directly hide ALL p elements in sticky bar
  sticky.querySelectorAll("p").forEach(function(p){p.style.setProperty("display","none","important");});
  // Inject our own per-serving text (always OT price = £1.32)
  var existing=sticky.querySelector("#mf-sticky-per-srv");
  if(!existing){
    var priceEl=sticky.querySelector(".price-item--sale,.price-item--regular,.price,.price-item");
    var wrapper=priceEl?priceEl.parentNode:sticky;
    var div=document.createElement("div");div.id="mf-sticky-per-srv";
    div.style.cssText="font-size:12px;color:#9ca3af;margin-top:1px;";
    div.textContent=PND+perSrv(OT.price)+" per serving";
    if(priceEl)wrapper.appendChild(div);
    else sticky.appendChild(div);
  }
}

function updateStickyPerServing(pence){
  var sp=document.getElementById("mf-sticky-per-srv");
  if(sp)sp.textContent=PND+perSrv(pence)+" per serving";
}

function onType(e){
  var val=e.target.value;
  var wrap=document.getElementById("mf-plan-wrap");
  var benefits=document.getElementById("mf-benefits");
  var gift=document.getElementById("mf-gift-box");
  var box=document.getElementById("mf-sub-picker");
  var otBox=document.getElementById("mf-ot-box");
  var badge=document.getElementById("mf-best-value");
  if(val==="sub"){
    var sel=document.getElementById("mf-plan-select");
    var plan=sel?PLANS.find(function(pl){return pl.id===parseInt(sel.value,10);}):PLANS[0];
    if(!plan)plan=PLANS[0];
    setSP(plan.id);updatePagePrice(plan.price);updatePickerPrice(plan.price);showStrike();updateStickyPerServing(plan.price);
    if(wrap)wrap.style.display="";
    if(benefits)benefits.style.display="";
    if(gift)gift.style.display="";
    if(badge)badge.style.display="";
    if(box){box.style.border="2px solid #111";box.style.background="#fff";}
    if(otBox){otBox.style.border="2px solid #d1d5db";otBox.style.background="#fafafa";}
  }else{
    rmSP();updatePagePrice(OT.price);hideStrike();updateStickyPerServing(OT.price);
    if(wrap)wrap.style.display="none";
    if(benefits)benefits.style.display="none";
    if(gift)gift.style.display="none";
    if(badge)badge.style.display="none";
    if(box){box.style.border="2px solid #d1d5db";box.style.background="#fafafa";}
    if(otBox){otBox.style.border="2px solid #111";otBox.style.background="#fff";}
  }
}

function isTubPage(){
  return location.pathname.indexOf("/products/match-fuel-hydration-focus-mixed-berry")===0;
}

function init(){
  var ps=document.querySelector(".product-information");
  if(!ps||document.getElementById("mf-sub-picker"))return;
  if(!isTubPage())return;

  var picker=document.createElement("div");
  picker.id="mf-sub-picker";
  picker.style.cssText="position:relative;margin:6px 0 4px 0;border:2px solid #111;border-radius:12px;padding:0 14px 12px 14px;background:#fff;";

  var bottleSvg='<img src="https://cdn.shopify.com/s/files/1/1057/4859/5027/files/MATCHFUELTUBS_9.png?width=88" style="width:44px;height:44px;object-fit:contain;border-radius:4px;flex-shrink:0;" alt="Match Fuel">';

  var h="";
  h+='<div id="mf-best-value" style="position:absolute;top:-13px;left:50%;transform:translateX(-50%);background:#16a34a;color:#fff;font-weight:700;font-size:11px;padding:4px 16px;border-radius:20px;letter-spacing:1px;white-space:nowrap;">BEST VALUE</div>';
  // Subscribe & Save header row
  h+='<div style="display:flex;align-items:flex-start;justify-content:space-between;margin-top:20px;margin-bottom:12px;">';
  h+='<label style="display:flex;align-items:flex-start;gap:10px;cursor:pointer;">';
  h+='<input type="radio" name="mf-purchase-type" value="sub" checked style="accent-color:#16a34a;width:18px;height:18px;margin-top:3px;flex-shrink:0;">';
  h+='<div><div style="font-weight:700;font-size:15px;letter-spacing:0.3px;">SUBSCRIBE &amp; SAVE</div>';
  h+='<div style="font-size:12px;color:#6b7280;margin-top:2px;">Auto-delivered to your door</div></div>';
  h+='</label>';
  h+='<div style="text-align:right;flex-shrink:0;margin-left:12px;">';
  h+='<div style="white-space:nowrap;"><s style="color:#9ca3af;font-size:13px;font-weight:400;">'+fmt(OT.price)+'</s> <span id="mf-picker-price" style="font-weight:700;font-size:16px;">'+fmt(PLANS[0].price)+'</span></div>';
  h+='<div id="mf-picker-per-serving" style="font-size:12px;color:#6b7280;">'+PND+perSrv(PLANS[0].price)+' per serving</div>';
  h+='</div></div>';
  // Dropdown
  h+='<div id="mf-plan-wrap" style="margin-bottom:12px;">';
  h+='<select id="mf-plan-select" style="width:100%;padding:10px 12px;border:1px solid #d1d5db;border-radius:8px;font-size:14px;font-weight:600;background:#fff;cursor:pointer;">';
  PLANS.forEach(function(pl){h+='<option value="'+pl.id+'">Delivery '+pl.name+' — '+fmt(pl.price)+'</option>';});
  h+='</select></div>';
  // Benefits
  h+='<div id="mf-benefits" style="margin-bottom:12px;">';
  ["Free delivery on every order","Cancel or pause anytime","Never run out before match day"].forEach(function(b){
    h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:5px;">';
    h+='<span style="color:#16a34a;font-weight:700;font-size:15px;">✓</span>';
    h+='<span style="font-size:13px;">'+b+'</span></div>';
  });
  h+='</div>';
  // Free gift
  h+='<div id="mf-gift-box" style="margin-top:4px;"><div style="display:flex;gap:10px;overflow-x:auto;">';
  [{name:"Sports Bottle",when:"2ND DELIVERY",img:"https://cdn.shopify.com/s/files/1/1057/4859/5027/files/MATCHFUELTUBS_8.png?width=200"},{name:"Performance Socks",when:"3RD DELIVERY",img:"https://cdn.shopify.com/s/files/1/1057/4859/5027/files/White_Match_Fuel_Grip_Socks_Duo.png?width=200"}].forEach(function(g){
    h+='<div style="flex:0 0 118px;border:1px solid #e5e7eb;border-radius:12px;padding:6px 6px 10px;text-align:center;background:#fff;">';
    h+='<div style="position:relative;background:#f3f4f6;border-radius:8px;height:96px;display:flex;align-items:center;justify-content:center;overflow:hidden;">';
    h+='<span style="position:absolute;top:5px;left:5px;background:#16a34a;color:#fff;font-size:9px;font-weight:800;letter-spacing:0.5px;padding:2px 6px;border-radius:4px;">FREE</span>';
    h+='<img src="'+g.img+'" alt="Free '+g.name+'" loading="lazy" width="80" height="80" style="width:80px;height:80px;object-fit:contain;mix-blend-mode:multiply;">';
    h+='</div>';
    h+='<div style="font-weight:700;font-size:12px;margin-top:8px;">'+g.name+'</div>';
    h+='<div style="font-size:10px;font-weight:700;color:#16a34a;letter-spacing:0.5px;margin-top:3px;">'+g.when+'</div>';
    h+='</div>';
  });
  h+='</div></div>';

  picker.innerHTML=h;

  // Separate one-time purchase box
  var otBox=document.createElement("div");
  otBox.id="mf-ot-box";
  otBox.style.cssText="margin:4px 0 6px 0;border:2px solid #d1d5db;border-radius:12px;padding:10px 14px;background:#fafafa;";
  otBox.innerHTML='<label style="display:flex;align-items:flex-start;gap:10px;cursor:pointer;">'+
    '<input type="radio" name="mf-purchase-type" value="ot" style="width:18px;height:18px;margin-top:3px;flex-shrink:0;">'+
    '<div style="flex:1;"><div style="display:flex;align-items:center;justify-content:space-between;">'+
    '<div style="font-weight:700;font-size:15px;letter-spacing:0.3px;">ONE-TIME PURCHASE</div>'+
    '<div style="text-align:right;flex-shrink:0;margin-left:12px;"><div style="font-weight:700;font-size:16px;">'+fmt(OT.price)+'</div><div style="font-size:12px;color:#9ca3af;margin-top:2px;">\xA31.32 per serving</div></div>'+
    '</div>'+
    '</div>'+
    '</label>';

  // Insert both boxes
  var badges=ps.querySelector(".product-badges,[class*='badges'],[class*='product-tags']");
  var buyBlock=ps.querySelector(".buy-buttons-block");
  var refNode=badges?(badges.nextSibling):(buyBlock||null);
  var refParent=badges?(badges.parentNode):(buyBlock?buyBlock.parentNode:ps);
  if(refNode){refParent.insertBefore(picker,refNode);refParent.insertBefore(otBox,refNode);}
  else{var pf=ps.querySelector(".product-form,form[action='/cart/add']");var cont=pf||ps;cont.appendChild(picker);cont.appendChild(otBox);}

  [picker,otBox].forEach(function(b){b.querySelectorAll("input[name='mf-purchase-type']").forEach(function(r){r.addEventListener("change",onType);});});
  var sel=document.getElementById("mf-plan-select");if(sel)sel.addEventListener("change",onPlan);
  updateMain(PLANS[0].price);showStrike();setSP(PLANS[0].id);
}

function fixShipsBar(){
  var shipsEl=document.querySelector(".mf-ships-bar");
  if(!shipsEl){
    var allEls=document.querySelectorAll(".product-information p,.product-information small");
    for(var i=0;i<allEls.length;i++){var t=allEls[i].textContent||"";if((t.indexOf("Ships")>-1||t.indexOf("shipping")>-1)&&t.length<150){shipsEl=allEls[i];break;}}
  }
  if(!shipsEl)return;
  var shipsParent=shipsEl.parentNode;
  if(!shipsParent)return;
  shipsParent.style.order="3";
  var flexContainer=shipsParent.parentNode;
  if(flexContainer){
    Array.from(flexContainer.children).forEach(function(c){
      if((c.className||"").indexOf("accordion")>-1){
        c.style.order="4";
      }
    });
  }
}

function hideDisclaimer(){
  var style=document.getElementById("mf-disc-style");
  if(!style){style=document.createElement("style");style.id="mf-disc-style";style.textContent=".shopify-payment-button small{display:none!important;}product-price p{display:none!important;}.payment-terms,[class*='payment-term'],shop-pay-installments-banner,shopify-payment-terms{display:none!important;}";document.head.appendChild(style);}
  document.querySelectorAll(".shopify-payment-button small,form[action='/cart/add'] small").forEach(function(s){s.style.display="none";});
  document.querySelectorAll("product-price p").forEach(function(el){el.style.display="none";});
}

function styleCardPrices(){
  var style=document.getElementById("mf-card-price-style");
  if(!style){
    style=document.createElement("style");style.id="mf-card-price-style";
    style.textContent="product-card .price-item--sale,product-card .price-item--regular,product-card .price,[class*='product-card'] .price-item--sale,[class*='product-card'] .price-item--regular,[class*='product-card'] .price{font-weight:700!important;font-size:13.8px!important;}.product-information .price__regular .price,.product-information .price__sale .price,.product-information .price-item--sale{font-weight:700!important;font-size:18px!important;}.buy-buttons-block{margin-top:4px!important;padding-top:0!important;}.payment-terms,.product-information [class*='payment-term'],shop-pay-installments-banner,shopify-payment-terms,.shopify-installments-banner,[id*='featured_product_information'] .payment-terms{display:none!important;}";
    document.head.appendChild(style);
  }
}

function hideCardRegPrices(){
  if(location.pathname.indexOf("/products/")===0&&location.pathname.length>10)return;
  document.querySelectorAll(".card-wrapper,.card--product,product-card,[class*='product-card']").forEach(function(card){
    var links=card.querySelectorAll("a");
    var isBundle=false;
    for(var j=0;j<links.length;j++){if((links[j].href||"").indexOf("bundle")>-1){isBundle=true;break;}}
    if(!isBundle){
      var compare=card.querySelector(".price__compare-at,[class*='compare']");
      if(compare)compare.style.display="none";
      var sale=card.querySelector(".price__sale");
      if(sale)sale.querySelectorAll(".price-item--regular,s").forEach(function(r){r.style.display="none";});
    }
    var reg=card.querySelector(".price__regular");
    if(reg){var ct=card.textContent||"";if(ct.indexOf("From")>-1)reg.style.display="none";}
  });
}

function fixBundlePagePrice(){
  if(location.pathname.indexOf("bundle")===-1)return;
  if(document.getElementById("mf-bdl-pfixed"))return;
  var ps=document.querySelector(".product-information");if(!ps)return;
  // Read compare-at & sale prices from DOM before hiding
  var compareAt="47.99";
  var compareEl=ps.querySelector(".price-item--regular.compare-at-price,.compare-at-price,.price__compare-at .price-item");
  if(compareEl){var ct=(compareEl.textContent||"").replace(/[^0-9.]/g,"").trim();if(ct)compareAt=ct;}
  var salePrice="36.99";
  var saleEl=ps.querySelector(".price-item--sale.price,.price-item--sale");
  if(saleEl){var sp2=(saleEl.textContent||"").replace(/[^0-9.]/g,"").trim();if(sp2)salePrice=sp2;}
  // Hide ALL native price elements including product-price itself (we replace with custom layout)
  if(!document.getElementById("mf-bdl-hide-style")){
    var hs=document.createElement("style");hs.id="mf-bdl-hide-style";
    hs.textContent=".product-information product-price,.product-information .price__regular,.product-information .price__sale,.product-information product-price .price{display:none!important;}.product-information #mf-bdl-price,.product-information #mf-bdl-shipping,.product-information #mf-bdl-pills{line-height:1.2;margin-top:0!important;}";
    document.head.appendChild(hs);
  }
  // Also directly hide elements
  ps.querySelectorAll("product-price,.price__regular,.price__sale").forEach(function(el){el.style.setProperty("display","none","important");});
  // Find parent to insert into
  var productPrice=ps.querySelector("product-price");
  var parent=productPrice?productPrice.parentNode:ps;
  // 1) Inline price row: ~~compareAt~~ salePrice GBP
  if(!document.getElementById("mf-bdl-price")){
    var pd=document.createElement("div");pd.id="mf-bdl-price";
    pd.style.cssText="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:0;margin-top:0;line-height:1.2;";
    pd.innerHTML='<s style="color:#9ca3af;font-size:14px;font-weight:400;">\xA3'+compareAt+'</s>'+
      '<span style="font-weight:700;font-size:18px;">\xA3'+salePrice+' GBP</span>';
    var priceComp=ps.querySelector("product-price");
    if(priceComp&&priceComp.parentNode)priceComp.parentNode.insertBefore(pd,priceComp);
    else parent.appendChild(pd);
  }
  // 2) Free UK Shipping line
  if(!document.getElementById("mf-bdl-shipping")){
    var shp=document.createElement("div");shp.id="mf-bdl-shipping";
    shp.style.cssText="font-size:13px;color:#9ca3af;margin-bottom:6px;margin-top:0;line-height:1.2;";
    shp.textContent="Free UK Shipping";
    var priceDiv=document.getElementById("mf-bdl-price");
    if(priceDiv&&priceDiv.parentNode)priceDiv.parentNode.insertBefore(shp,priceDiv.nextSibling);
    else parent.appendChild(shp);
  }
  // 3) Pill badges
  if(!document.getElementById("mf-bdl-pills")){
    var pills=document.createElement("div");pills.id="mf-bdl-pills";
    pills.style.cssText="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:4px;margin-top:0;";
    ["Sugar Free","Made for Footballers","Trusted Worldwide","Elite Taste"].forEach(function(label){
      var p=document.createElement("span");
      p.style.cssText="display:inline-block;border:1px solid #d1d5db;border-radius:20px;padding:4px 12px;font-size:12px;color:#6b7280;background:#f9fafb;white-space:nowrap;";
      p.textContent=label;pills.appendChild(p);
    });
    var shpEl=document.getElementById("mf-bdl-shipping");
    if(shpEl&&shpEl.parentNode)shpEl.parentNode.insertBefore(pills,shpEl.nextSibling);
    else parent.appendChild(pills);
  }
  var done=document.createElement("span");done.id="mf-bdl-pfixed";done.style.display="none";
  ps.appendChild(done);
}

function initCardSubtext(){
  if(location.pathname.indexOf("/products/")===0&&location.pathname.length>10)return;
  document.querySelectorAll(".card-wrapper,.card--product,product-card,[class*='product-card']").forEach(function(card){
    if(card.querySelector(".mf-card-sub"))return;
    var links=card.querySelectorAll("a");
    var isBundle=false;var isTub=false;
    for(var j=0;j<links.length;j++){
      var href=(links[j].href||"");
      if(href.indexOf("bundle")>-1)isBundle=true;
      if(href.indexOf("match-fuel-hydration")>-1||href.indexOf("mixed-berry")>-1||href.indexOf("hydration-focus")>-1)isTub=true;
    }
    if(!isBundle&&!isTub)return;
    var sub=document.createElement("div");
    sub.className="mf-card-sub";
    sub.style.cssText="margin:3px 0 0 0;font-size:12px;color:#9ca3af;font-weight:400;line-height:1.3;";
    if(isBundle){sub.textContent="Free UK Shipping";}
    else{sub.textContent="\xA31.08 per serving";}
    // Insert INSIDE product-price (as div, not p, so hidden-p CSS won't affect it)
    // product-price has 54px padding-bottom; inserting inside puts subtext right after price text
    var ppEl=card.querySelector("product-price");
    if(ppEl){ppEl.appendChild(sub);}
    else{var priceEl=card.querySelector(".price");if(!priceEl)return;priceEl.parentNode.insertBefore(sub,priceEl.nextSibling);}
  });
}

function styleReviews(){
  var isTub=isTubPage();
  var isBundle=location.pathname.indexOf("bundle")>-1;
  if(!isTub&&!isBundle)return;
  if(document.getElementById("mf-inline-reviews"))return;
  var outerLink=document.querySelector("a.mf-review-badge");
  var badge=document.querySelector(".jdgm-prev-badge");
  var rating="4.9/5";var count="53";
  if(badge){
    var rEl=badge.querySelector("[class*='average-rating'],[class*='average'],[class*='score']");
    if(rEl){var rt=(rEl.textContent||"").replace(/[^\d.]/g,"").substring(0,3);if(rt)rating=rt;}
    var cEl=badge.querySelector("[class*='reviews-count'],[class*='count']");
    if(cEl){var ct=(cEl.textContent||"").replace(/[^0-9]/g,"");if(ct)count=ct;}
  }
  if(!document.getElementById("mf-review-hide-style")){
    var st=document.createElement("style");st.id="mf-review-hide-style";
    st.textContent="a.mf-review-badge,.jdgm-prev-badge{display:none!important;}.price__per-serving,.price__unit-price,.price__per-unit,[data-price-per-unit]{display:none!important;}product-price p{display:none!important;}";
    document.head.appendChild(st);
  }
  if(outerLink)outerLink.style.cssText="display:none!important;";
  if(badge)badge.style.cssText="display:none!important;";
  var div=document.createElement("div");
  div.id="mf-inline-reviews";
  div.style.cssText="display:flex;align-items:center;gap:10px;margin:8px 0 12px 0;flex-wrap:wrap;";
  div.innerHTML='<span style="font-size:22px;color:#f59e0b;letter-spacing:2px;">★★★★★</span>'+
    '<span style="font-weight:700;font-size:17px;">'+rating+'</span>'+
    '<a href="/pages/reviews" style="font-size:15px;color:#111;text-decoration:underline;cursor:pointer;font-weight:500;">'+count+' customer reviews</a>';
  var ps=document.querySelector(".product-information");if(!ps)return;
  if(isBundle){
    // Bundle: find "Everything you need" heading, replace with reviews line, keep rest
    var needEl=null;
    var allEls=ps.querySelectorAll("p,h2,h3,h4,strong,b");
    for(var i=0;i<allEls.length;i++){
      var t=(allEls[i].textContent||"");
      if(t.indexOf("Everything you need")>-1||t.indexOf("stay sharp")>-1){needEl=allEls[i];break;}
    }
    if(needEl&&needEl.parentNode){
      var target=needEl.tagName==="P"?needEl:(needEl.closest("p")||needEl);
      target.parentNode.insertBefore(div,target);
      target.style.display="none";
    }else{
      var title=ps.querySelector("h1,.product__title,[class*='product-title']");
      if(title&&title.parentNode){title.parentNode.insertBefore(div,title.nextSibling);}
      else{ps.insertAdjacentElement("afterbegin",div);}
    }
    return;
  }
  // Tub page: find "Perform" text to replace
  var performEl=null;
  var candidates=ps.querySelectorAll("p,h2,h3,h4");
  for(var i=0;i<candidates.length;i++){
    var txt=(candidates[i].textContent||"").trim();
    if(txt.length>0&&txt.length<120&&(txt.indexOf("Perform")>-1||txt.indexOf("perform")>-1)){
      performEl=candidates[i];break;
    }
  }
  if(performEl&&performEl.parentNode){
    performEl.style.display="none";
    performEl.parentNode.insertBefore(div,performEl);
  }else{
    var title=ps.querySelector("h1,.product__title,[class*='product-title']");
    if(title&&title.parentNode){title.parentNode.insertBefore(div,title.nextSibling);}
    else{ps.insertAdjacentElement("afterbegin",div);}
  }
}

function initCart(){
  if(location.pathname!=="/cart")return;
  fetch("/cart.js").then(function(r){return r.json();}).then(function(cart){
    var subItem=cart.items.find(function(i){return i.selling_plan_allocation;});
    if(!subItem)return;var disc=OT.price-subItem.price;if(disc<=0)return;
    var totals=document.querySelector(".totals,[class*='totals']");
    if(!totals||document.getElementById("mf-cart-disc"))return;
    var div=document.createElement("div");div.id="mf-cart-disc";
    div.style.cssText="display:flex;justify-content:space-between;padding:8px 0;";
    div.innerHTML='<span style="font-size:14px;color:#16a34a;font-weight:600;">Subscription discount</span><span style="font-size:14px;color:#16a34a;font-weight:600;">-'+fmt(disc)+'</span>';
    totals.insertAdjacentElement("afterbegin",div);
  }).catch(function(){});
}

function styleHeroBtn(){
  if(location.pathname!=="/")return;
  if(document.getElementById("mf-hero-btn-style"))return;
  var st=document.createElement("style");st.id="mf-hero-btn-style";
  st.textContent=".hero__content-wrapper a[class*='button-secondary']{background:#fff!important;color:#000!important;border-color:#fff!important;transition:transform 0.25s ease!important;font-weight:700!important;padding:8px 14px!important;font-size:16px!important;}.hero__content-wrapper a[class*='button-secondary']:hover{transform:scale(1.06)!important;background:#fff!important;color:#000!important;}";
  document.head.appendChild(st);
}

function run(){init();hideDisclaimer();fixShipsBar();hideCardRegPrices();styleCardPrices();initCardSubtext();initCart();styleReviews();fixBundlePagePrice();fixHomeBundleSection();fixStickyBar();styleHeroBtn();}
if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",run);}else{run();}
setTimeout(run,1200);
setTimeout(hideDisclaimer,2500);
setTimeout(fixShipsBar,2500);
setTimeout(hideCardRegPrices,2500);
setTimeout(styleCardPrices,2500);
setTimeout(initCardSubtext,2500);
setTimeout(styleReviews,2500);
setTimeout(fixBundlePagePrice,2500);
setTimeout(fixBundlePagePrice,4500);
setTimeout(fixHomeBundleSection,2500);
setTimeout(fixStickyBar,2500);
setTimeout(fixStickyBar,4000);
setTimeout(styleHeroBtn,1000);

function fixHomeBundleSection(){
  if(location.pathname!=="/")return;
  if(document.getElementById("mf-home-bdl-done"))return;
  var section=document.querySelector('[id*="featured_product_information"]');
  if(!section)return;
  var ps=section.querySelector(".product-information");
  if(!ps)return;
  // Hide "Featured product" label at top of section
  var allSectionEls=Array.from(section.querySelectorAll("p,h2,h3,h4,span,div"));
  for(var i=0;i<allSectionEls.length;i++){
    var et=allSectionEls[i];
    if((et.textContent||"").trim()==="Featured product"&&!et.querySelector("*")){et.style.display="none";break;}
  }
  // Inject CSS to force-hide review badges in this section (handles late Judgeme rendering)
  if(!document.getElementById("mf-home-bdl-style")){
    var hideStyle=document.createElement("style");hideStyle.id="mf-home-bdl-style";
    hideStyle.textContent="[id*='featured_product_information'] a.mf-review-badge,[id*='featured_product_information'] .jdgm-prev-badge{display:none!important;}[id*='featured_product_information'] .payment-terms,[id*='featured_product_information'] .price__taxes,[id*='featured_product_information'] .tax-note,[id*='featured_product_information'] shop-pay-installments-banner,[id*='featured_product_information'] shopify-payment-terms{display:none!important;}";
    document.head.appendChild(hideStyle);
  }
  var badge=section.querySelector("a.mf-review-badge,.jdgm-prev-badge");
  if(badge)badge.style.display="none";
  // Insert our custom reviews line
  if(!document.getElementById("mf-home-reviews")){
    var div=document.createElement("div");
    div.id="mf-home-reviews";
    div.style.cssText="display:flex;align-items:center;gap:10px;margin:8px 0 12px 0;flex-wrap:wrap;";
    div.innerHTML='<span style="font-size:22px;color:#f59e0b;letter-spacing:2px;">★★★★★</span>'+
      '<span style="font-weight:700;font-size:17px;">4.9/5</span>'+
      '<a href="/pages/reviews" style="font-size:15px;color:#111;text-decoration:underline;cursor:pointer;font-weight:500;">53 customer reviews</a>';
    var needEl=null;
    var allEls=ps.querySelectorAll("p,h2,h3,h4,strong,b");
    for(var j=0;j<allEls.length;j++){
      var t=(allEls[j].textContent||"");
      if(t.indexOf("Everything you need")>-1||t.indexOf("stay sharp")>-1){needEl=allEls[j];break;}
    }
    if(needEl&&needEl.parentNode){
      var target=needEl.tagName==="P"?needEl:(needEl.closest("p")||needEl);
      target.parentNode.insertBefore(div,target);
      target.style.display="none";
    }else{
      var titleEl=ps.querySelector("h1,h2,[class*='product-title']");
      if(titleEl&&titleEl.parentNode)titleEl.parentNode.insertBefore(div,titleEl.nextSibling);
      else ps.insertAdjacentElement("afterbegin",div);
    }
  }
  // Fix price: inline strikethrough + main price + Free UK Shipping
  if(!document.getElementById("mf-home-price")){
    var priceRegular=ps.querySelector(".price__regular");
    var priceSale=ps.querySelector(".price__sale");
    var priceParent=priceRegular?priceRegular.parentNode:(priceSale?priceSale.parentNode:null);
    if(priceParent){
      if(priceRegular)priceRegular.style.display="none";
      if(priceSale)priceSale.style.display="none";
      var pd=document.createElement("div");
      pd.id="mf-home-price";
      pd.style.cssText="display:flex;align-items:center;gap:8px;margin-bottom:2px;flex-wrap:wrap;";
      pd.innerHTML='<s style="color:#9ca3af;font-size:14px;font-weight:400;">\xA342.99</s>'+
        '<span style="font-weight:700;font-size:18px;">\xA336.99 GBP</span>';
      priceParent.insertBefore(pd,priceRegular||priceSale);
      if(!document.getElementById("mf-home-shipping")){
        var shp=document.createElement("div");
        shp.id="mf-home-shipping";
        shp.style.cssText="font-size:13px;color:#9ca3af;margin-top:2px;";
        shp.textContent="Free UK Shipping";
        priceParent.insertBefore(shp,pd.nextSibling);
      }
      if(!document.getElementById("mf-home-pills")){
        var pills=document.createElement("div");
        pills.id="mf-home-pills";
        pills.style.cssText="display:flex;flex-wrap:wrap;gap:6px;margin-top:10px;";
        ["Sugar Free","Made for Footballers","Trusted Worldwide","Elite Taste"].forEach(function(label){
          var p=document.createElement("span");
          p.style.cssText="display:inline-block;border:1px solid #d1d5db;border-radius:20px;padding:4px 12px;font-size:12px;color:#6b7280;background:#f9fafb;white-space:nowrap;";
          p.textContent=label;
          pills.appendChild(p);
        });
        var shpEl=document.getElementById("mf-home-shipping");
        if(shpEl&&shpEl.parentNode)shpEl.parentNode.insertBefore(pills,shpEl.nextSibling);
        else priceParent.appendChild(pills);
      }
    }
  }
  var done=document.createElement("span");
  done.id="mf-home-bdl-done";
  done.style.display="none";
  ps.appendChild(done);
}

function styleNavbar(){
  if(location.pathname==="/")return;
  var id="mf-nav-style";
  var hdr=document.querySelector("header-component");
  function syncScroll(){
    if(!hdr)hdr=document.querySelector("header-component");
    if(!hdr)return;
    var dark=window.scrollY>60;
    if(dark){hdr.classList.add("mf-scrolled");}
    else{hdr.classList.remove("mf-scrolled");}
    var logoImg=hdr.querySelector(".header-logo__image");
    if(logoImg){
      var link=logoImg.closest("a");
      if(!logoImg.__mfT){logoImg.style.transition="filter 0.45s ease";logoImg.__mfT=true;}
      if(link&&!link.__mfT){
        link.style.transition="opacity 0.45s ease";
        link.__mfT=true;
        link.style.setProperty("pointer-events","auto","important");
        link.style.setProperty("cursor","pointer","important");
        link.style.setProperty("position","relative","important");
        link.style.setProperty("z-index","100","important");
        if(!link.getAttribute("href")||link.getAttribute("href")==="#"){link.setAttribute("href","/")}
      }
      if(dark){
        logoImg.style.setProperty("filter","none","important");
        if(link)link.style.removeProperty("opacity");
      }else{
        logoImg.style.setProperty("filter","brightness(0) saturate(100%)","important");
        if(link)link.style.setProperty("opacity","1","important");
      }
    }
  }
  if(!window.__mfScrollBound){window.__mfScrollBound=true;window.addEventListener("scroll",syncScroll,{passive:true});}
  syncScroll();
  if(!document.getElementById(id)){
    var s=document.createElement("style");s.id=id;
    s.textContent=
      "header-component{transition:background 0.45s ease,box-shadow 0.45s ease;}"
      +"header-component:not(.mf-scrolled) .header__row *{color:#000!important;}"
      +".header-logo a,.header-logo__image,.spacing-style.size-style.header-logo{pointer-events:auto!important;cursor:pointer!important;}"
      +"header-component:not(.mf-scrolled) .header__icons svg path,"
      +"header-component:not(.mf-scrolled) .header__icons svg rect,"
      +"header-component:not(.mf-scrolled) .header__icons svg circle,"
      +"header-component:not(.mf-scrolled) .header__icons svg ellipse,"
      +"header-component:not(.mf-scrolled) .header__icons svg polygon,"
      +"header-component:not(.mf-scrolled) .header__icons svg line,"
      +"header-component:not(.mf-scrolled) .header__icons svg polyline{fill:none!important;stroke:#000!important;stroke-width:1.5px!important;}"
      +"main#MainContent{padding-top:var(--header-height,80px)!important;}";
    document.head.appendChild(s);
  }
  setTimeout(syncScroll,500);
  setTimeout(syncScroll,1500);
}
if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",styleNavbar);}else{styleNavbar();}
setTimeout(styleNavbar,800);
})();}

(function(){var s=document.createElement("style");s.textContent="#mf-sub-picker{margin-bottom:0!important;padding-bottom:6px!important;}#mf-ot-box{margin-top:2px!important;}";document.head.appendChild(s);})();

;(function(){if(window.__mfBundleLoaded)return;window.__mfBundleLoaded=true;if(location.pathname.indexOf('/products/match-fuel-hydration-focus-mixed-berry')!==0)return;var BOTTLE_IMG='https://cdn.shopify.com/s/files/1/1057/4859/5027/files/MATCHFUELTUBS_8.png';var BUNDLE_VID='53366069428563';function createUpsell(){if(document.getElementById('mf-bundle-upsell'))return;var otBox=document.getElementById('mf-ot-box');if(!otBox)return;var div=document.createElement('div');div.id='mf-bundle-upsell';div.style.cssText='display:none;margin:0 0 4px 0;border:2px solid #e5e7eb;border-radius:12px;padding:12px 14px;background:#f9fafb;cursor:pointer;';div.innerHTML='<div style="font-size:10px;color:#9ca3af;letter-spacing:1.5px;text-transform:uppercase;font-weight:600;margin-bottom:8px;">COMPLETE THE BUNDLE</div><div style="display:flex;align-items:center;gap:12px;"><img src="'+BOTTLE_IMG+'" style="width:52px;height:52px;object-fit:contain;border-radius:8px;flex-shrink:0;" alt="Match Fuel Bottle"><div style="flex:1;"><div style="font-weight:700;font-size:14px;letter-spacing:0.3px;">Add the Match Fuel Bottle</div><div style="font-size:12px;color:#16a34a;font-weight:600;margin-top:2px;">Complete your bundle for just \xA34 more</div><div style="font-size:11px;color:#16a34a;font-weight:600;margin-top:1px;">+ free shipping</div></div><div style="text-align:right;flex-shrink:0;"><div style="font-size:12px;color:#9ca3af;text-decoration:line-through;">\xA39.99</div><div style="font-weight:700;font-size:15px;color:#16a34a;">+\xA34.00</div></div><div id="mf-bundle-toggle" style="width:24px;height:24px;border:2px solid #d1d5db;border-radius:50%;background:#fff;flex-shrink:0;display:flex;align-items:center;justify-content:center;transition:all 0.2s;margin-left:8px;"></div></div>';otBox.insertAdjacentElement('afterend',div);div.addEventListener('click',function(){var sel=div.dataset.sel==='1';var toggle=document.getElementById('mf-bundle-toggle');var form=document.querySelector("form[action='/cart/add']");var idInput=form?form.querySelector("input[name='id']"):null;if(!sel){div.dataset.sel='1';div.style.border='2px solid #111';div.style.background='#fff';if(toggle){toggle.style.background='#111';toggle.style.borderColor='#111';toggle.innerHTML='<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';}if(idInput){if(!idInput.dataset.orig)idInput.dataset.orig=idInput.value;idInput.value=BUNDLE_VID;}var priceEl=document.querySelector('.product-information .price__regular .price,.product-information .price__sale .price');if(priceEl)priceEl.textContent='\xA336.99 GBP';}else{div.dataset.sel='0';div.style.border='2px solid #e5e7eb';div.style.background='#f9fafb';if(toggle){toggle.style.background='#fff';toggle.style.borderColor='#d1d5db';toggle.innerHTML='';}if(idInput&&idInput.dataset.orig)idInput.value=idInput.dataset.orig;var priceEl2=document.querySelector('.product-information .price__regular .price,.product-information .price__sale .price');if(priceEl2)priceEl2.textContent='\xA332.99 GBP';}});}document.addEventListener('change',function(e){if(e.target.name!=='mf-purchase-type')return;if(e.target.value==='ot'){createUpsell();var u=document.getElementById('mf-bundle-upsell');if(u)u.style.display='';}else if(e.target.value==='sub'){var u2=document.getElementById('mf-bundle-upsell');if(u2){if(u2.dataset.sel==='1'){var form=document.querySelector("form[action='/cart/add']");var idInput=form?form.querySelector("input[name='id']"):null;if(idInput&&idInput.dataset.orig)idInput.value=idInput.dataset.orig;u2.dataset.sel='0';}u2.style.display='none';}}});function checkState(){var otRadio=document.querySelector('input[name="mf-purchase-type"][value="ot"]');if(otRadio&&otRadio.checked){createUpsell();var u=document.getElementById('mf-bundle-upsell');if(u)u.style.display='';}}setTimeout(checkState,1600);setTimeout(checkState,2600);})();